﻿export class BrandLandingPage {
    public static setLogo($: JQueryStatic): void {
        function setLogo(img) {
            const path = "/Blob/img/m&b-brands/";

            $(".brand-page__logo").attr("src", path + img);
        }

        if ($("body").hasClass("harvester")) {
            setLogo("harvester-white.png");
        } else if ($("body").hasClass("allbarone")) {
            //setLogo('all-bar-one-gold-bg.png');
            setLogo("all-bar-one.png");
        } else if ($("body").hasClass("browns")) {
            setLogo("browns.png");
        } else if ($("body").hasClass("emberinns")) {
            setLogo("ember.png");
        } else if ($("body").hasClass("millerandcarter")) {
            setLogo("miller-and-carter-white.png");
        } else if ($("body").hasClass("nicholsons")) {
            //setLogo('nicholsons.png');
            setLogo("nicholsons-trns.png");
        } else if ($("body").hasClass("sizzling")) {
            setLogo("sizzling.svg");
        } else if ($("body").hasClass("stonehouse")) {
            //setLogo('stonehouse.png');
            //setLogo('stonehouse-trns.png');
            setLogo("stonehouse-shadow.png");
        } else if ($("body").hasClass("toby")) {
            setLogo("toby.png");
        } else if ($("body").hasClass("castle")) {
            setLogo("castle.png");
            //setLogo('castle-trns.png');
        } else if ($("body").hasClass("vintage")) {
            setLogo("vintage-white.png");
        } else if ($("body").hasClass("oneils")) {
            //setLogo('oneils.png');
            setLogo("oneils-trns.png");
        } else if ($("body").hasClass("orleans")) {
            setLogo("orleans-logo.png");
        } else if ($("body").hasClass("countrypubs")) {
            //setLogo('pcp-trns.png');
            // setLogo('pcp-white.png');
            setLogo("pcp-logo-v2.png");
        } else if ($("body").hasClass("neighbourhood-pubs")) {
            setLogo("neighbourhood-pubs.png");
        } else if ($("body").hasClass("ego")) {
            setLogo("ego.png");
        } else if ($("body").hasClass("brand-page")) {
            setLogo("mb-brand-logo.png");
        }
    }
}
